<template>
  <div class="admin-navbar">
    <div class="admin-navbar_items">
      <router-link class="admin-navbar_items-item" :exact="false" to="/admin/adminHistoryPage">Добавить Историю</router-link>
      <router-link class="admin-navbar_items-item" :exact="false" to="/admin/adminVideoPage">Добавить Видео</router-link>
      <router-link class="admin-navbar_items-item" :exact="false" to="/admin/adminCommentsPage">Добавить Отзыв</router-link>
      <router-link class="admin-navbar_items-item" :exact="false" to="/admin/adminRequestsPage">Заявки</router-link>
      <router-link class="admin-navbar_items-item" :exact="false" to="/admin/adminPricePage">Цены</router-link>
      <div @click="Logout" class="admin-navbar_items-item">Выйти </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "AdminNav",
    methods: {
      ...mapActions('auth', ['logout']),
      Logout() {
        this.logout()
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="scss">
  .admin-navbar {
    width: 220px;
    box-shadow: 2px 0 4px 1px rgba(92, 82, 115, 0.07);
    background-color: #ffffff;
    height: calc(100vh - 82px);
    float: left;
    position: fixed;
    &_items {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      &-item {
        width: 100%;
        padding: 16px 25px;
        cursor: pointer;
        text-decoration: none;
        font-weight: bold;
        color: #19223d;
      }
      &-item.router-link-active {
        background-color: #f8f8f8;
      }
    }
  }
  a:hover {
    text-decoration: none;
  }
</style>